import fetch from '@/utils/fetch'

/**
 *  检查是否有红包
 */
export function getRedPacketCheckData(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/re/check',
    method: 'post',
    data
  })
}

/**
 * 打开红包
 */
export function openRedPacket(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/re/open',
    method: 'post',
    data
  })
}

/**
 * 获取订单列表头
 */
export function getOrderListHeader(data = {}) {
  return fetch({
    url: '/api_order/service/w/order/buyer/order/list/header',
    method: 'post',
    data
  })
}

/**
 * 获取订单列表
 */
export function getOrderList(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/order/list',
    method: 'post',
    data
  })
}

/**
 * 获取订单详情
 */
export function getOrderDetail(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/order/get',
    method: 'post',
    data
  })
}

/**
 * 关闭订单
 */
export function closeOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/close',
    method: 'post',
    data
  })
}

/**
 * 确认收货
 */
export function receiveOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/order/receive',
    method: 'post',
    data
  })
}

/**
 * 初始化售票订单
 */
export function initTicketOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/ticket/init',
    method: 'post',
    data
  })
}

/**
 * 计算售票订单
 */
export function calculateTicketOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/ticket/calculate',
    method: 'post',
    data
  })
}

/**
 * 创建售票订单
 */
export function createTicketOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/buyer/ticket/create',
    method: 'post',
    data
  })
}

/**
 * 初始化商城订单
 */
export function initShopOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/v391/init',
    method: 'post',
    data
  })
}

/**
 * 计算商城订单
 */
export function calculateShopOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/calculate',
    method: 'post',
    data
  })
}

/**
 * 创建商城订单
 */
export function createShopOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/create',
    method: 'post',
    data
  })
}

/**
 * 获取微信支付参数
 */
export function getWxPayParam(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/use/wxpay',
    method: 'post',
    data
  })
}

/**
 * 订单查询
 */
export function queryOrder(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/query',
    method: 'post',
    data
  })
}
